<template>
  <div class="p-5">
    <ProjectOptionsPanel
      v-if="showProjectOptionsPanel"
      :project="project"
      @create-survey="showCreateSurveyForm = true"
      @project-unsynced="$emit('project-unsynced')"
    />
    <SurveyDetails
      v-if="showSurveyDetails"
      :project="project"
      :token="token"
      :otlfbSurvey="project.otlfbSurvey"
      :redcapProjectInfo="redcapProjectInfo"
      @survey-deleted="$emit('survey-deleted')"
      @project-unsynced-from-user="$emit('project-unsynced')"
    />
  </div>
    <CreateSurveyForm
    v-if="showCreateSurveyForm"
    :project="project"
    :redcapProjectInProduction="redcapProjectInfo.in_production === 1"
    @cancel="showCreateSurveyForm = false"
    @otlfb-survey-saved="onSurveySaved"
  />
</template>

<script setup>
import { ref, computed, watch } from "vue"
import SurveyDetails from "../components/SurveyDetails.vue"
import CreateSurveyForm from "../components/CreateSurveyForm.vue"
import ProjectOptionsPanel from "../components/ProjectOptionsPanel.vue"

const emit = defineEmits(["survey-saved", "project-unsynced", "survey-deleted"])

const props = defineProps({
  project: {
    type: Object,
    required: true
  },
  redcapProjectInfo: {
    type: Object,
    required: true
  },
  token: {
    type: [String, Object],
    required: false,
    default: ''
  }
})

const showCreateSurveyForm = ref(false)
const showSurveyDetails = computed(() =>
  Boolean(props.project?.otlfbSurvey?.id)
)
const showProjectOptionsPanel = computed(
  () => !showCreateSurveyForm.value && !showSurveyDetails.value
)

function onSurveySaved() {
  showCreateSurveyForm.value = false
  emit('survey-saved')
}

watch(() => props.project, () => {
  showCreateSurveyForm.value = false
})

</script>
